import React from 'react'
import { Toast } from '@grammarly/design-system'

import styles from '../tool.module.scss'
import { useTool } from '../tool-context'

export const ToolErrorToast: React.FC = () => {
  const { toolError, setToolError } = useTool()

  if (toolError) {
    return (
      <div className={styles.toastContainer}>
        <Toast text={toolError} variant="critical" onClose={() => setToolError(null)} />
      </div>
    )
  }

  return null
}
